// Roughly how many characters a name column shows before it clips. Used to
// decide whether a cell needs a tooltip carrying the full name: repeating a
// name that is already fully visible is noise, so the tooltip is only offered
// past this. Deliberately low — a tooltip nobody needed costs nothing, a
// clipped name with no way to read it costs the user the information.
const VISIBLE_NAME_CHARS = 24;

/** Whether a name is long enough that its cell probably clips it. */
export function mayClip(name: string | null | undefined): boolean {
  return (name ?? '').length > VISIBLE_NAME_CHARS;
}
